
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { ICharitableContribution, LGEDataService } from 'src/commons';
import { LoadCharitableContributionState, LoadCharitableContributionStateSuccess, LoadCharitableContributionStateFail, CharitableContributionActionTypes } from './charitable-contribution.actions';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';
@Injectable()
export class CharitableContributionEffects {

  loadCharitableContributionState$ = createEffect(
    () => this.actions$.pipe(
      ofType(CharitableContributionActionTypes.LoadCharitableContributionState),
      map((action: LoadCharitableContributionState) => action.formId),
      switchMap(
        (Id) => from(this.dataService.formCCById(Id)).pipe(
          map((state: ICharitableContribution) => new LoadCharitableContributionStateSuccess(state)),
          catchError((error: Error) => of(new LoadCharitableContributionStateFail(error)))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private dataService: LGEDataService
  ) { }
}